import { atomWithReset } from 'jotai/utils'

import {
  type DisplayRowId,
  type FiveSegmentDisplayColumnKey,
  type FiveSegmentSortColumnKey,
  type NineSegmentDisplayColumnKey,
  type NineSegmentSortColumnKey,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import {
  type DataDisplayType,
  type SegmentDisplayType,
  type SortValue,
} from '~/utils'

export const dataDisplayTypeAtom = atomWithReset<DataDisplayType>('percentage')
export const segmentDisplayTypeAtom =
  atomWithReset<SegmentDisplayType>('fiveSegs')

export const fiveSegmentSortValueAtom =
  atomWithReset<SortValue<FiveSegmentSortColumnKey> | null>(null)
export const nineSegmentSortValueAtom =
  atomWithReset<SortValue<NineSegmentSortColumnKey> | null>(null)

export const hiddenRowIdsAtom = atomWithReset<DisplayRowId[]>([])

export const fiveSegmentCommentAtom = atomWithReset('')
export const savedFiveSegmentCommentAtom = atomWithReset('')
export const fiveSegmentHiddenColumnKeysAtom = atomWithReset<
  FiveSegmentDisplayColumnKey[]
>([])
export const nineSegmentCommentAtom = atomWithReset('')
export const savedNineSegmentCommentAtom = atomWithReset('')
export const nineSegmentHiddenColumnKeysAtom = atomWithReset<
  NineSegmentDisplayColumnKey[]
>([])
